import React, { useState, useEffect } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { UserCircle, LockKey, Eye, EyeSlash } from 'phosphor-react';

import { startSigninPage, signin } from 'redux/actions/pages';
import AuthShell from './home-components/AuthShell';
import FormField from './home-components/FormField';
import { STORE_LINKS } from './home-components/homeContent';
import playstoreImage from 'assets/img/playstore-badge.png';
import appstoreImage from 'assets/img/appstore-badge.png';
import CustomAlert from './CustomAlert';
import CustomLoading from './CustomLoading';

function LoginPage({ auth, redirectTo, startScreen, signinAction }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    startScreen();

    // eslint-disable-next-line
  }, [auth]);

  useEffect(() => {
    if (redirectTo && redirectTo !== '' && redirectTo !== '/signin') {
      history.push(redirectTo);
    }
    // eslint-disable-next-line
  }, [redirectTo]);

  const onSigninClick = (e) => {
    e.preventDefault();
    signinAction({ email, password });
  };

  return (
    <>
      <CustomAlert />
      <CustomLoading />
      <AuthShell
        path="/signin"
        hideSignin
        asideTitle="Okumaya kaldığın yerden devam et"
        aside={
          <>
            <ul className="op-auth__points">
              <li>
                <span aria-hidden="true">🎒</span>
                Öğrenciler kitaplarına, görevlerine ve mesajlarına ulaşır.
              </li>
              <li>
                <span aria-hidden="true">🍎</span>
                Öğretmenler aynı ekrandan girer, öğretmen paneline otomatik
                yönlendirilir.
              </li>
              <li>
                <span aria-hidden="true">📱</span>
                Tablette ve telefonda Okuma Platformu Okul uygulamasıyla.
              </li>
            </ul>
            <div className="op-badges">
              <a href={STORE_LINKS.okul.appStore} target="_blank" rel="noreferrer">
                <img src={appstoreImage} alt="Okuma Platformu Okul - App Store'dan indir" />
              </a>
              <a href={STORE_LINKS.okul.googlePlay} target="_blank" rel="noreferrer">
                <img src={playstoreImage} alt="Okuma Platformu Okul - Google Play'den indir" />
              </a>
            </div>
          </>
        }
      >
        <span className="op-kicker">Giriş</span>
        <h1>Tekrar hoş geldin!</h1>
        <p className="op-auth__lead">
          Okulunun verdiği kullanıcı adı ve şifreyle giriş yap.
        </p>
        <form className="op-auth__form" method="post" onSubmit={onSigninClick}>
          <FormField id="signin-user" label="Kullanıcı adı veya e-posta" icon={UserCircle}>
            <input
              id="signin-user"
              type="text"
              name="email"
              autoComplete="username"
              autoCapitalize="none"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </FormField>
          <FormField id="signin-password" label="Şifre" icon={LockKey}>
            <input
              id="signin-password"
              type={showPassword ? 'text' : 'password'}
              name="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
            <button
              type="button"
              className="op-auth__reveal"
              aria-label={showPassword ? 'Şifreyi gizle' : 'Şifreyi göster'}
              aria-pressed={showPassword}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeSlash size={20} /> : <Eye size={20} />}
            </button>
          </FormField>
          <div className="op-auth__row">
            <Link className="op-auth__link" to="/forgot-password">
              Şifremi unuttum
            </Link>
          </div>
          <button className="op-btn op-btn--primary op-btn--lg op-auth__submit" type="submit">
            Giriş Yap
          </button>
        </form>
        <p className="op-auth__foot">
          Okulunuzun hesabı yok mu? <a href="/buy-now">Teklif isteyin</a>
        </p>
      </AuthShell>
    </>
  );
}

const mapStateToProps = (state) => ({
  auth: state.auth,
  redirectTo: state.ui.redirectTo,
});

const mapDispatchToProps = {
  startScreen: startSigninPage,
  signinAction: signin,
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);
